(function(){
  function initLS(root){
  var drawer = root.querySelector('.ls-drawer-root');
  if(!drawer) return;

  var THRESH = parseInt(root.getAttribute('data-thresh'),10) || 0;
  var PRODUCTS = (function(){ try{ return JSON.parse((root.querySelector('.ls-data')||{}).textContent||'[]'); }catch(e){ return []; } })();
  var BY_PID = {}; PRODUCTS.forEach(function(p){ BY_PID[p.pid] = p; });

  var grid = root.querySelector('[data-grid]');
  var cards = Array.prototype.slice.call(grid.querySelectorAll('.ls-card'));
  var emptyEl = grid.querySelector('[data-empty]');
  var state = { cat:'all', fit:'All', q:'', sort:'featured' };

  /* ---------- smart search engine (synonyms + typo tolerance + relevance) ---------- */
  function tokenize(s){ return (s||'').toLowerCase().split(/[^a-z0-9]+/).filter(Boolean); }
  cards.forEach(function(c){
    c._tw = tokenize(c.getAttribute('data-name'));                                  // title tokens (weighted)
    c._kw = tokenize(c.getAttribute('data-kw') || c.getAttribute('data-name'));     // full keyword blob
  });
  var SYN_GROUPS=[
    ['membrane','ro','osmosis','reverse','seawater','element'],
    ['filter','prefilter','cartridge','sediment','pleated','micron','carbon'],
    ['pump','triplex','pumptec','impeller','diaphragm','booster','feed','catpump'],
    ['gauge','pressure','psi','bar'],
    ['flow','flowmeter','meter','lpm','lph'],
    ['tds','sensor','salinity','quality'],
    ['uv','steriliser','sterilizer','steralizer'],
    ['valve','ball','check','needle','relief','nonreturn'],
    ['fitting','connector','elbow','tee','joiner','pushfit','barb','stem','bulkhead','union','reducer','adapter','adaptor'],
    ['hose','tube','tubing','pipe'],
    ['seal','oring','gasket'],
    ['kit','bundle','service','install'],
    ['chemical','cleaning','clean','preserve','preservative','descale','descalant','maintenance','storage'],
    ['power','supply','psu','volt','watt'],
    ['electronic','electronics','fuse','anderson','plug','battery','disconnect','electrical','wiring','holder'],
    ['intake','strainer','suction'],
    ['stainless','316','304','marine']
  ];
  var SYN={};
  SYN_GROUPS.forEach(function(g){ g.forEach(function(t){ SYN[t]=SYN[t]||[]; g.forEach(function(x){ if(SYN[t].indexOf(x)<0) SYN[t].push(x); }); }); });
  function expand(term){
    var out=[term], g=SYN[term], i;
    if(g) for(i=0;i<g.length;i++) if(out.indexOf(g[i])<0) out.push(g[i]);
    if(term.length>3 && term.charAt(term.length-1)==='s'){           // crude singular
      var sg=term.slice(0,-1); if(out.indexOf(sg)<0) out.push(sg);
      var g2=SYN[sg]; if(g2) for(i=0;i<g2.length;i++) if(out.indexOf(g2[i])<0) out.push(g2[i]);
    }
    return out;
  }
  function ed1(a,b){                                                  // true if Levenshtein distance <= 1
    var la=a.length, lb=b.length; if(Math.abs(la-lb)>1) return false;
    var i=0,j=0,diff=0;
    while(i<la && j<lb){
      if(a[i]===b[j]){ i++; j++; }
      else { if(++diff>1) return false; if(la>lb) i++; else if(lb>la) j++; else { i++; j++; } }
    }
    if(i<la||j<lb) diff++;
    return diff<=1;
  }
  function termScore(c, term){
    var vars=expand(term), best=0, i, k, w, v;
    for(k=0;k<vars.length;k++){ v=vars[k];
      for(i=0;i<c._tw.length;i++){ w=c._tw[i];
        if(w===v) best=Math.max(best,3);
        else if(v.length>=2 && w.indexOf(v)===0) best=Math.max(best,2.5);
        else if(v.length>=2 && w.indexOf(v)>-1) best=Math.max(best,2);
      }
      for(i=0;i<c._kw.length;i++){ w=c._kw[i];
        if(w===v) best=Math.max(best,1.5);
        else if(v.length>=2 && w.indexOf(v)===0) best=Math.max(best,1.2);
        else if(v.length>=2 && w.indexOf(v)>-1) best=Math.max(best,1);
      }
    }
    if(best===0 && term.length>=4){                                  // typo tolerance on the raw term
      for(i=0;i<c._kw.length;i++){ if(ed1(c._kw[i],term)){ best=0.8; break; } }
    }
    return best;
  }

  /* ---------- formatting ---------- */
  function money(cents){
    return '$' + (cents/100).toLocaleString('en-AU',{minimumFractionDigits:2,maximumFractionDigits:2});
  }
  function esc(s){ return String(s==null?'':s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];}); }

  /* ---------- category counts ---------- */
  (function(){
    var counts={all:cards.length};
    cards.forEach(function(c){ var k=c.getAttribute('data-cat'); counts[k]=(counts[k]||0)+1; });
    root.querySelectorAll('[data-cat-count]').forEach(function(el){
      var k=el.getAttribute('data-cat-count'); el.textContent=counts[k]!=null?counts[k]:0;
    });
  })();

  /* ---------- filtering + sorting ---------- */
  function applyFilters(){
    var qTokens = tokenize(state.q);
    var visible=[];
    cards.forEach(function(c){
      var okCat = state.cat==='all' || c.getAttribute('data-cat')===state.cat;
      var fits = (c.getAttribute('data-fits')||'').split(' ');
      var okFit = state.fit==='All' || fits.indexOf(state.fit)>-1 || fits.indexOf('Universal')>-1;
      var score=0, okQ=true;
      for(var t=0;t<qTokens.length;t++){ var s=termScore(c, qTokens[t]); if(s<=0){ okQ=false; break; } score+=s; }
      var show = okCat && okFit && okQ;
      c.hidden = !show;
      c._score = score;
      if(show) visible.push(c);
    });
    // sort by relevance when searching, else by the chosen sort; reorder DOM nodes
    visible.sort(function(a,b){
      if(qTokens.length){ var d=(b._score||0)-(a._score||0); if(d) return d; }
      if(state.sort==='low')  return (+a.getAttribute('data-price')) - (+b.getAttribute('data-price'));
      if(state.sort==='high') return (+b.getAttribute('data-price')) - (+a.getAttribute('data-price'));
      return (b.getAttribute('data-featured')==='true'?1:0) - (a.getAttribute('data-featured')==='true'?1:0);
    });
    visible.forEach(function(c){ grid.insertBefore(c, emptyEl); });
    emptyEl.hidden = visible.length!==0;
    var rc=root.querySelector('[data-result-count]'); if(rc) rc.textContent=visible.length;
  }

  function setCat(c){ state.cat=c; root.querySelectorAll('[data-cat]').forEach(function(b){ b.classList.toggle('is-active', b.getAttribute('data-cat')===c); }); applyFilters(); }
  function setFit(f){
    state.fit=f;
    root.querySelectorAll('[data-fit-filter]').forEach(function(b){ b.classList.toggle('is-active', b.getAttribute('data-fit-filter')===f); });
    root.querySelectorAll('[data-fit]').forEach(function(b){ b.classList.toggle('is-active', b.getAttribute('data-fit')===f); });
    applyFilters();
  }

  root.querySelectorAll('[data-cat]').forEach(function(b){ b.addEventListener('click', function(){ setCat(b.getAttribute('data-cat')); }); });
  root.querySelectorAll('[data-fit-filter]').forEach(function(b){ b.addEventListener('click', function(){ setFit(b.getAttribute('data-fit-filter')); }); });
  root.querySelectorAll('[data-fit]').forEach(function(b){
    b.addEventListener('click', function(){
      setFit(b.getAttribute('data-fit'));
      var tb=root.querySelector('.ls-toolbar'); if(tb) tb.scrollIntoView({behavior:'smooth',block:'start'});
    });
  });
  var searchEl=root.querySelector('[data-search]');
  if(searchEl){
    searchEl.addEventListener('input', function(){ state.q=searchEl.value; applyFilters(); });
    // dismiss the mobile keyboard when the Search/Enter key (or the clear "x") is pressed
    searchEl.addEventListener('keydown', function(e){ if(e.key==='Enter'){ e.preventDefault(); searchEl.blur(); } });
    searchEl.addEventListener('search', function(){ searchEl.blur(); });
  }
  // mobile: collapse/expand the category + fits + sort filters; the search bar stays visible
  var fToggle=root.querySelector('[data-filter-toggle]');
  var toolbarEl=root.querySelector('.ls-toolbar');
  if(fToggle && toolbarEl) fToggle.addEventListener('click', function(){
    var open=toolbarEl.classList.toggle('is-open');
    fToggle.setAttribute('aria-expanded', open?'true':'false');
  });
  var sortEl=root.querySelector('[data-sort]');
  if(sortEl) sortEl.addEventListener('change', function(){ state.sort=sortEl.value; applyFilters(); });
  var resetEl=root.querySelector('[data-reset]');
  if(resetEl) resetEl.addEventListener('click', function(){ state.q=''; if(searchEl) searchEl.value=''; setCat('all'); setFit('All'); });

  /* ---------- variant selection ---------- */
  /* prevent the mousedown from moving focus/scrolling the page (and from the click
     ever reaching the underlying product image link) */
  root.addEventListener('mousedown', function(e){
    if(e.target.closest('.ls-variant,.ls-quickadd,.ls-add')) e.preventDefault();
  });
  root.addEventListener('click', function(e){
    var chip=e.target.closest('.ls-variant'); if(!chip||chip.disabled) return;
    e.preventDefault(); e.stopPropagation();
    var holder=chip.closest('.ls-variants');
    holder.querySelectorAll('.ls-variant').forEach(function(v){ v.classList.remove('is-sel'); });
    chip.classList.add('is-sel');
  });

  /* ---------- add to cart ---------- */
  function selectedVid(btn){
    var card=btn.closest('.ls-card');
    if(card){ var sel=card.querySelector('.ls-variant.is-sel'); if(sel && sel.getAttribute('data-vid')) return sel.getAttribute('data-vid'); }
    return btn.getAttribute('data-vid');
  }
  function addToCart(vid, btn){
    if(!vid) return;
    if(btn){ btn.disabled=true; }
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(vid),quantity:1}]})})
      .then(function(r){ return r.json().then(function(d){ if(!r.ok) throw d; return d; }); })
      .then(function(){ openDrawer(); return refreshCart(); })
      .catch(function(err){ alert((err && err.description) || 'Sorry — could not add that item.'); })
      .finally(function(){ if(btn) btn.disabled=false; });
  }
  /* ---------- mobile variant picker (replaces long-press): "Add" opens the picker, "View" opens the product ---------- */
  function closeAllPanels(except){ var o=root.querySelectorAll('.ls-card.is-open'); for(var i=0;i<o.length;i++){ if(o[i]!==except) o[i].classList.remove('is-open'); } }
  function lsMobile(){ return window.matchMedia('(max-width:768px)').matches; }
  // bound to document so add buttons inside the drawer (suggestions) also work
  document.addEventListener('click', function(e){
    var card=e.target.closest('.ls-card');
    closeAllPanels(card);                                   // close any picker the tap is outside of
    var btn=e.target.closest('[data-add]'); if(!btn) return;
    if(!root.contains(btn) && !drawer.contains(btn)) return;
    e.preventDefault(); e.stopPropagation();
    // on mobile the grid card's "Add" opens the variant picker (when there are options) instead of adding directly
    if(lsMobile() && btn.classList.contains('ls-add') && card && card.querySelector('.ls-variant') && !card.classList.contains('is-open')){
      card.classList.add('is-open');
      return;
    }
    addToCart(selectedVid(btn), btn);
    if(card) card.classList.remove('is-open');
  });
  // tapping anywhere outside an open card closes its picker
  document.addEventListener('touchstart', function(e){ if(!e.target.closest('.ls-card.is-open')) closeAllPanels(); }, {passive:true});

  /* ---------- drawer open/close ---------- */
  function openDrawer(){ drawer.hidden=false; drawer.setAttribute('aria-hidden','false'); document.body.style.overflow='hidden'; }
  function closeDrawer(){ drawer.hidden=true; drawer.setAttribute('aria-hidden','true'); document.body.style.overflow=''; }
  drawer.querySelectorAll('[data-close]').forEach(function(el){ el.addEventListener('click', closeDrawer); });
  document.addEventListener('keydown', function(e){ if(e.key==='Escape' && !drawer.hidden) closeDrawer(); });
  // Let an existing theme cart link open this drawer instead of navigating away.
  document.querySelectorAll('a[href="/cart"],a[href$="/cart"]').forEach(function(a){
    a.addEventListener('click', function(e){ e.preventDefault(); openDrawer(); refreshCart(); });
  });
  var checkoutBtn=drawer.querySelector('[data-checkout]');
  if(checkoutBtn) checkoutBtn.addEventListener('click', function(){ window.location.href='/checkout'; });

  /* ---------- cart change/remove ---------- */
  function changeLine(key, qty){
    fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity:qty})})
      .then(function(r){ return r.json(); }).then(function(){ return refreshCart(); });
  }

  /* ---------- cross-sell suggestions (domain-aware pairing) ---------- */
  // classify a product into a companion "type" from its title/category
  function lsType(p){
    var t=(p.title||'').toLowerCase(), c=p.cat;
    if(/membrane|reverse osmosis|osmosis/.test(t)) return 'membrane';
    if(/chemical|cleaning|clean\b|preserv|descal|pickl|maintenance/.test(t)) return 'chemical';
    if(/\boil\b|crank/.test(t)) return 'oil';
    if(c==='Pumps' && /kit/.test(t)) return 'pumpkit';
    if(/gauge|pressure/.test(t)) return 'gauge';
    if(/\btds\b|sensor|salinity/.test(t)) return 'tds';
    if(/flow ?meter|\bmeter\b/.test(t)) return 'flow';
    if(/cutter/.test(t)) return 'cutter';
    if(/intake|strainer/.test(t)) return 'intake';
    if(/valve|check/.test(t)) return 'valve';
    if(/fuse|anderson|plug|battery|disconnect|wiring/.test(t)) return 'electrical';
    if(c==='Filters' || /filter|cartridge|prefilter|pre-filter|sediment/.test(t)) return 'prefilter';
    if(c==='Fittings' || /pushfit|connector|elbow|\btee\b|joiner|barb|union|reducer|hose|tube/.test(t)) return 'fitting';
    if(c==='Pumps') return 'pump';
    return 'part';
  }
  // what each companion type pairs with in the cart, the reason shown, and a weight
  var LS_RULES={
    chemical:{reason:'Clean & preserve your membrane',w:{membrane:3,filter:2,kit:2,pump:1}},
    prefilter:{reason:'Replace at every service',w:{membrane:3,filter:2,pump:1}},
    oil:{reason:'Top up your pump',w:{pump:3}},
    pumpkit:{reason:'Service your pump',w:{pump:3}},
    gauge:{reason:'Monitor your pressure',w:{pump:2,filter:1,membrane:1}},
    tds:{reason:'Check your water quality',w:{membrane:2,filter:2,electronic:1}},
    flow:{reason:'Track your output',w:{pump:1,filter:1,membrane:1}},
    valve:{reason:'Protect your plumbing',w:{fitting:2,pump:2,filter:1}},
    cutter:{reason:'For clean tubing cuts',w:{fitting:3}},
    intake:{reason:'Protect your feed',w:{pump:2,filter:2}},
    fitting:{reason:'Finish the plumbing',w:{fitting:2,pump:1,filter:1}},
    electrical:{reason:'Wire it up safely',w:{electronic:3,pump:1}},
    membrane:{reason:'',w:{}}, pump:{reason:'',w:{}}, part:{reason:'',w:{}}
  };
  function buildSuggestions(cart){
    var inCart={}, cartFits={}, ctx={membrane:false,pump:false,filter:false,fitting:false,electronic:false,kit:false};
    cart.items.forEach(function(it){
      inCart[it.product_id]=true;
      var p=BY_PID[it.product_id], c=p?p.cat:'', tt=(it.product_title||'').toLowerCase();
      if(p) p.fits.forEach(function(f){ cartFits[f]=true; });
      if(c==='Pumps') ctx.pump=true;
      if(c==='Filters'){ ctx.filter=true; if(/membrane|osmosis/.test(tt)) ctx.membrane=true; }
      if(c==='Fittings') ctx.fitting=true;
      if(c==='Electronics') ctx.electronic=true;
      if(c==='Kits') ctx.kit=true;
    });
    var hasFits=Object.keys(cartFits).length>0, scored=[];
    PRODUCTS.forEach(function(p){
      if(!p.available || inCart[p.pid]) return;
      var type=lsType(p), rule=LS_RULES[type]||LS_RULES.part, sc=0, k;
      for(k in rule.w){ if(ctx[k]) sc+=rule.w[k]; }
      var fitOK = !hasFits || p.fits.indexOf('Universal')>-1 || p.fits.some(function(f){ return cartFits[f]; });
      if(sc>0 && p.fits.indexOf('Universal')>-1) sc+=0.5;   // universal parts suit any build
      if(!fitOK) sc*=0.3;                                    // wrong system → much less relevant
      if(sc<=0){ if(p.addon && fitOK) sc=0.15; else return; } // generic consumable fallback
      scored.push({p:p, type:type, sc:sc, reason:rule.reason||p.reason||'Common service part'});
    });
    scored.sort(function(a,b){ return b.sc-a.sc || a.p.price-b.p.price; });
    // diversify: one per companion type first, then fill any remaining slots
    var out=[], usedType={}, leftovers=[];
    scored.forEach(function(s){ if(out.length<3 && !usedType[s.type]){ usedType[s.type]=1; out.push(s); } else leftovers.push(s); });
    for(var i=0; out.length<3 && i<leftovers.length; i++) out.push(leftovers[i]);
    return out.slice(0,3).map(function(s){ return Object.assign({}, s.p, {reason:s.reason}); });
  }

  /* ---------- render drawer from /cart.js ---------- */
  function refreshCart(){
    return fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){ return r.json(); }).then(function(cart){
      var count=cart.item_count, sub=cart.total_price;
      drawer.querySelector('[data-cart-count]').textContent='('+count+')';

      // free shipping progress
      var ship=drawer.querySelector('[data-ship]');
      if(THRESH>0 && count>0){
        ship.hidden=false;
        var msg=drawer.querySelector('[data-ship-msg]');
        if(sub>=THRESH){ msg.className='ls-ship-msg is-free'; msg.innerHTML='✓ You’ve unlocked free shipping'; }
        else { msg.className='ls-ship-msg'; msg.innerHTML='Add <strong>'+money(THRESH-sub)+'</strong> for free shipping'; }
        drawer.querySelector('[data-ship-fill]').style.width=Math.min(100, sub/THRESH*100)+'%';
      } else { ship.hidden=true; }

      // line items
      var body=drawer.querySelector('[data-cart-body]');
      if(count===0){
        body.innerHTML='<div class="ls-cart-empty"><div class="t">Your cart is empty</div><div>Add parts to get started.</div></div>';
      } else {
        body.innerHTML=cart.items.map(function(it){
          return '<div class="ls-citem">'
            +'<div class="ls-citem-img">'+(it.image?'<img src="'+esc(it.image)+'" alt="">':'')+'</div>'
            +'<div class="ls-citem-main">'
              +'<div class="ls-citem-name">'+esc(it.product_title)+(it.variant_title?' — '+esc(it.variant_title):'')+'</div>'
              +'<div class="ls-citem-unit">'+money(it.final_price)+'</div>'
              +'<div class="ls-citem-ctl">'
                +'<div class="ls-qty"><button type="button" data-dec="'+esc(it.key)+'">−</button><span>'+it.quantity+'</span><button type="button" data-inc="'+esc(it.key)+'">+</button></div>'
                +'<button type="button" class="ls-citem-rm" data-rm="'+esc(it.key)+'">Remove</button>'
              +'</div>'
            +'</div>'
            +'<div class="ls-citem-line">'+money(it.final_line_price)+'</div>'
          +'</div>';
        }).join('');
      }

      // suggestions
      var sugWrap=drawer.querySelector('[data-suggest]');
      var sugList=drawer.querySelector('[data-suggest-list]');
      var sugs = count>0 ? buildSuggestions(cart) : [];
      if(sugs.length){
        sugWrap.hidden=false;
        sugList.innerHTML=sugs.map(function(p){
          return '<div class="ls-srow">'
            +'<div class="ls-srow-img">'+(p.img?'<img src="'+esc(p.img)+'" alt="">':'')+'</div>'
            +'<div class="ls-srow-main"><div class="ls-srow-name">'+esc(p.title)+'</div>'
              +'<div class="ls-srow-meta"><span class="ls-srow-price">'+esc(p.priceFmt)+'</span><span style="color:#8C93A4;">·</span><span class="ls-srow-reason">'+esc(p.reason)+'</span></div></div>'
            +'<button type="button" class="ls-srow-add" data-add data-vid="'+p.id+'"><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>Add</button>'
          +'</div>';
        }).join('');
      } else { sugWrap.hidden=true; }

      // footer
      var foot=drawer.querySelector('[data-foot]');
      if(count>0){ foot.hidden=false; drawer.querySelector('[data-subtotal]').textContent=money(sub); }
      else { foot.hidden=true; }
    });
  }

  // delegated qty / remove (drawer is rebuilt each refresh)
  drawer.addEventListener('click', function(e){
    var inc=e.target.closest('[data-inc]'), dec=e.target.closest('[data-dec]'), rm=e.target.closest('[data-rm]');
    if(inc){ var k=inc.getAttribute('data-inc'); var q=parseInt(inc.previousElementSibling.textContent,10)||0; changeLine(k,q+1); }
    else if(dec){ var k2=dec.getAttribute('data-dec'); var q2=parseInt(dec.nextElementSibling.textContent,10)||0; changeLine(k2,Math.max(0,q2-1)); }
    else if(rm){ changeLine(rm.getAttribute('data-rm'),0); }
  });

  /* ---------- dispatch countdown (2pm Australia/Brisbane, Mon–Fri) ---------- */
  (function(){
    var el=root.querySelector('[data-dispatch]'); if(!el) return;
    function tick(){
      var now=new Date();
      var bne=new Date(now.toLocaleString('en-US',{timeZone:'Australia/Brisbane'}));
      var day=bne.getDay(); // 0 Sun … 6 Sat
      var cutoff=new Date(bne); cutoff.setHours(14,0,0,0);
      var diff=cutoff-bne;
      if(day>=1 && day<=5 && diff>0){
        var h=Math.floor(diff/3600000), m=Math.floor((diff%3600000)/60000);
        el.innerHTML='Order within <strong class="ls-mono" style="font-weight:600;">'+h+'h '+m+'m</strong> for same-day dispatch';
      } else {
        el.textContent='Order now — ships next business day';
      }
    }
    tick(); setInterval(tick,60000);
  })();

  /* ---------- init ---------- */
  applyFilters();
  refreshCart();
}
  document.querySelectorAll('.ls-root').forEach(initLS);
})();
